import request from '@/lib/request.mjs';

export default function (id) {
  if (id) {
    return request('setAccount', { body: { id } });
  } else {
    return request('unsetAccount');
  }
}
